import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const image: SxStyle = {
  width: '100%',
  display: 'block',
  borderRadius: (p) => p.spacing(0.5),
};

/** Keeps the check aligned when a feature label wraps to a second line. */
export const checkIcon: SxStyle = {
  flexShrink: 0,
};
